import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import Creator3DStandalone from '../studio/three/Creator3DStandalone';

export default function ThreeDViewer({ url, onAnnotate, fitContainer }: { url: string; onAnnotate: () => void, fitContainer?: boolean }) {
  const [expanded, setExpanded] = useState(false);

  const ExpandedView = expanded ? createPortal(
    <div
      className="threed-modal-backdrop"
      style={{
        position: 'fixed', inset: 0, zIndex: 999999, padding: 0, background: '#0a0a0a'
      }}
    >
      <Creator3DStandalone onClose={() => setExpanded(false)} />
    </div>,
    document.body
  ) : null;

  return (
    <>
      {!expanded && (
        <div 
          className="glass glass--flat"
          style={fitContainer ? {
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            width: '100%', height: '100%',
            overflow: 'hidden',
            background: '#0a0a0a'
          } : { 
            position: 'relative', 
            width: '100%', 
            maxWidth: '480px', 
            height: '320px', 
            borderRadius: 'var(--radius)', 
            overflow: 'hidden', 
            border: '1px solid var(--line)',
            background: '#0a0a0a'
          }}
        >
          <div style={{ width: '100%', height: '100%', position: 'relative' }}>
             <Creator3DStandalone fitContainer={true} />
             {!fitContainer && (
               <div style={{ position: 'absolute', top: '12px', right: '12px', zIndex: 10, display: 'flex', gap: '6px' }}>
                 <button className="btn btn--icon glass glass--strong" onClick={() => setExpanded(!expanded)} title={expanded ? "Collapse" : "Expand"}>
                   {expanded ? (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"/></svg>
                   ) : (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>
                   )}
                 </button>
               </div>
             )}
          </div>
        </div>
      )}
      
      {ExpandedView}

      {!fitContainer && !expanded && (
        <div style={{ display: 'flex', gap: '6px', alignItems: 'center', marginTop: '6px' }}>
          <button 
            className="btn btn--primary annotator-action-button"
            style={{ minHeight: '22px', fontSize: '9px', padding: '0 8px', gap: '4px' }}
            onClick={onAnnotate}
          >
            <span>🖌️</span> Annotate
          </button>
        </div>
      )}
    </>
  );
}
